const config = {
  featureServices: [
    { name: "Island Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/91" },
    { name: "Marine Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/119" },
    { name: "Terrestrial Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/93" },
  ],
  Print: {
    //printServiceUrl: "https://edp.ead.ae/server/rest/services/AlDaleela/Print_AlDaleela/GPServer/Export%20Web%20Map",
    printServiceUrl: "https://devedp.ead.ae/server/rest/services/AlDaleela/AlDaleela_PrintTemplate/GPServer/Export%20Web%20Map",
    allowedFormats: ["Portable Document Format (PDF)","32-bit Portable Network Graphics (PNG32)", "Joint Photographic Experts Group (JPG)"],
    allowedLayouts: ["Print"]
  },
  Export: {
    //printServiceUrlAr: "https://edp.ead.ae/server/rest/services/AlDaleela/Print_AlDaleela_Arabic/GPServer/Export%20Web%20Map",
    printServiceUrlAr: "https://devedp.ead.ae/server/rest/services/AlDaleela/ExportWebMap_Arabic/GPServer/Export%20Web%20Map",
    //printServiceUrlEng: "https://edp.ead.ae/server/rest/services/AlDaleela/Print_AlDaleela_English/GPServer/Export%20Web%20Map",
    printServiceUrlEng: "https://devedp.ead.ae/server/rest/services/AlDaleela/ExportWebMap_English/GPServer/Export%20Web%20Map",
    allowedFormats: ["32-bit Portable Network Graphics (PNG32)", "Joint Photographic Experts Group (JPG)"],
    allowedLayouts: ["Export"]
  },
  layerListServices: {
    english: [
      {
        parent: {name:"Scale based Labelling",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/95", visible: true},
        children: [
          { name: "Island  Names", id:"Island Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/91", visible: true },
          { name: "Marine  Names", id:"Marine Names",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/119", visible: true },
          { name: "Terrestrial  Names", id:"Terrestrial Names",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/93", visible: true },
          { name: "Protected Areas", id:"Protected Areas",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/90", visible: false },
          { name: "Pearl Sites", id:"Pearl Sites",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/89", visible: false }
        ]
      },
      {
        parent: {name:"Cluster",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/108", visible: false},
        children: [
          { name: "Island  Names", id:"Island Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/111", visible: true },
          { name: "Marine  Names", id:"Marine Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/110", visible: true },
          { name: "Terrestrial  Names", id:"Terrestrial Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/109", visible: true },
          { name: "Protected Areas", id:"Protected Areas", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/116", visible: false },
          { name: "Pearl Sites", id:"Pearl Sites", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/115", visible: false }
        ]
      }
    ],
    arabic: [
      {
        parent: {name:"التسمية حسب المقياس",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/103", visible: true},
        children: [
          { name: "مسميات الجزر",id:"Island Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/102", visible: true },
          { name: "المسميات البحرية",id:"Marine Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/101", visible: true },
          { name: "المسميات البرية",id:"Terrestrial Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/100", visible: true },
          { name: "المحميات الطبيعية", id:"Protected Areas",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/96", visible: false },
          { name: "مغاصات اللولو",id:"Pearl Sites", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/97", visible: false }
        ]
      },
      {
        parent: {name:"التكتل",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/104", visible: false},
        children: [
          { name: "مسميات الجزر",id:"Island Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/2", visible: true },
          { name: "المسميات البحرية",id:"Marine Names", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/105", visible: true },
          { name: "المسميات البرية", id:"Terrestrial Names",url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/3", visible: true },
          { name: "المحميات الطبيعية",id:"Protected Areas", url: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/107", visible: false },
          { name: "مغاصات اللولو",id:"Pearl Sites", url: "https://devedp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/106", visible: false }
        ]
      }
    ]
  },
  basemapsConfig: {
    Arabic: [
      {
        title: "خريطة أساس رمادية داكنة بالعربية - الإحداثيات الجغرافية",
        id: "Basemap Arabic Dark Gray Geographic coordinates",
        thumbnailImg: "./images/Basemap Arabic Dark Gray Geographic coordinates.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_DarkGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "خريطة أساس رمادية داكنة بالعربية - إحداثيات ويب ميركاتور",
      //   id: "Basemap Arabic Dark Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/Arabic Dark Gray Web Mercator .png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_DarkGray_WM/MapServer"
      //   ]
      // },
      {
        title: "خريطة أساس رمادية فاتحة بالعربية - الإحداثيات الجغرافية",
        id: "Basemap Arabic Light Gray Geographic coordinates",
        thumbnailImg: "./images/Arabic light Gray Geographic.jpg",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_LightGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "خريطة أساس رمادية فاتحة بالعربية - إحداثيات ويب ميركاتور",
      //   id: "Basemap Arabic Light Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/Arabic light Gray Web Mercator.png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_LightGray_WM/MapServer"
      //   ]
      // },
      {
        title: "صور الأقمار الصناعية",
        id: "Satellite imagery Arabic",
        thumbnailImg: "./images/ESRI Satellite Imagery.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/arcgis/rest/services/Pub/IMG_SAT_50CM_WM/MapServer"
        ]
      },
      {
        title: "صور الأقمار الصناعية",
        id: "Satellite imagery Arabic",
        thumbnailImg: "./images/ESRI World Imagery.png",
        baseLayers: [
          "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
        ]
      }
    ],
    English: [
      {
        title: "Dark Gray Geographic",
        id: "Basemap English Dark Gray Geographic coordinates",
        thumbnailImg: "./images/English Dark Gray Geographic.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_DarkGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "English Dark Gray Web Mercator",
      //   id: "Basemap English Dark Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/English Dark Gray Web Mercator.png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_DarkGray_WM/MapServer"
      //   ]
      // },
      {
        title: "Light Gray Geographic",
        id: "Basemap English Light Gray Geographic coordinates",
        thumbnailImg: "./images/English light Gray Geographic.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_LightGray_GCS/MapServer"
        ]
      },
      // {
      //   title: "English Light Gray Web Mercator",
      //   id: "Basemap English Light Gray Web Mercator coordinates",
      //   thumbnailImg: "./images/English Light Gray Web Mercator.png",
      //   baseLayers: [
      //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_LightGray_WM/MapServer"
      //   ]
      // },
      {
        title: "Satellite Imagery",
        id: "Satellite imagery English",
        thumbnailImg: "./images/ESRI Satellite Imagery.png",
        baseLayers: [
          "https://arcgis.sdi.abudhabi.ae/arcgis/rest/services/Pub/IMG_SAT_50CM_WM/MapServer"
        ]
      },
      {
        title: "Satellite Imagery",
        id: "Satellite imagery English",
        thumbnailImg: "./images/ESRI World Imagery.png",
        baseLayers: [
          "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
        ]
      }
    ]
  },
  PortalUrl: "https://edp.ead.ae/portal",
  ItemWebMapIDEng: "2b20c82d957d4276a8fb21353c5cc642",
  BaseUrl: "https://edp.ead.ae/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer"
};

export default config;
